import React, { useEffect, useState } from "react"

const RegistryItemPreview = ({ img, handleClick, name, addToItems, id }) => {
  const [quantity, setQuantity] = useState(0)
  if (quantity < 0) {
    setQuantity(0)
  }

  useEffect(() => {
    if (quantity > 0) {
      addToItems(items => {
        const filterItems = items.filter(x => x.product !== id)
        return [{ product: id, quantity: quantity }, ...filterItems]
      })
    }
  }, [quantity, id, addToItems])

  return (
    <div
      className={`w-52 h-56 p-4 ${
        quantity > 0 ? "bg-purple-200" : "bg-white"
      } cursor-pointer`}
      onClick={handleClick}
    >
      <img className="w-full h-4/6 object-cover" alt="sample" src={img} />
      <h2 className="mt-2 text-grey text-lg font-bold">{name}</h2>
      <div className="w-full px-1 flex justify-between border border-gray-200 items-center h-10">
        <span
          className="w-6 h-6 flex justify-center items-center text-xl text-white bg-gray-300 rounded-full"
          onClick={() => setQuantity(quantity - 1)}
        >
          -
        </span>
        <p>{`${quantity}`}</p>
        <span
          className="w-6 h-6 flex justify-center items-center text-xl text-white bg-green-300 rounded-full"
          onClick={() => setQuantity(quantity + 1)}
        >
          +
        </span>
      </div>
    </div>
  )
}

export default RegistryItemPreview
